import { Filter } from '@cubejs-client/core';
import { useMemo } from 'react';

import { SpendType } from '~/common/types/cubes/SpendType';
import { useConfig } from '~/components/ConfigProvider';

interface UseStrategicSpendFilterProps {
  cubeTotalVolumeField: string;
  spendType: SpendType;
}

export const useSpendTypeFilter = ({ spendType, cubeTotalVolumeField }: UseStrategicSpendFilterProps): Filter[] => {
  const { widgets } = useConfig();
  const strategicSpendThreshold = widgets?.strategicSpendThreshold ?? 0;

  return useMemo(() => {
    const spendTypeFilterMap: Record<SpendType, Filter[]> = {
      [SpendType.ALL]: [],
      [SpendType.STRATEGIC_SPEND]: [
        {
          member: cubeTotalVolumeField,
          operator: 'gte',
          values: [`${strategicSpendThreshold}`],
        },
      ],
      [SpendType.TAIL_SPEND]: [
        {
          or: [
            {
              member: cubeTotalVolumeField,
              operator: 'lt',
              values: [`${strategicSpendThreshold}`],
            },
            {
              member: cubeTotalVolumeField,
              operator: 'notSet',
            },
          ],
        },
      ],
    };
    return spendTypeFilterMap[spendType];
  }, [cubeTotalVolumeField, spendType, strategicSpendThreshold]);
};
